import { theme } from '../constants';
import { CheckIcon } from './Icons';

const STEPS = [
  { id: 1, label: 'Current Property' },
  { id: 2, label: 'Device' },
  { id: 3, label: 'New Property' },
];

/**
 * Three-dot progress rail. `currentStep` is the first step still needing input;
 * everything before it renders as complete.
 */
function StepIndicator({ currentStep }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {STEPS.map((step, index) => {
        const done = step.id < currentStep;
        const active = step.id === currentStep;

        return (
          <div key={step.id} style={{ display: 'flex', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span
                style={{
                  width: 22,
                  height: 22,
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11,
                  fontWeight: 700,
                  transition: 'all 0.2s',
                  background: done ? theme.accent : active ? theme.accentSoft : '#f3f4f6',
                  border: `1.5px solid ${done || active ? theme.accent : theme.border}`,
                  color: done ? '#fff' : active ? theme.accent : theme.textFaint,
                }}
              >
                {done ? <CheckIcon size={12} /> : step.id}
              </span>
              <span
                style={{
                  fontSize: 12.5,
                  fontWeight: active ? 700 : 600,
                  color: done || active ? theme.text : theme.textFaint,
                  whiteSpace: 'nowrap',
                }}
              >
                {step.label}
              </span>
            </div>
            {index < STEPS.length - 1 && (
              <span
                style={{
                  width: 34,
                  height: 2,
                  margin: '0 12px',
                  borderRadius: 2,
                  background: done ? theme.accent : theme.border,
                  transition: 'background 0.2s',
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
}

export default StepIndicator;
